import { auth } from './firebaseConfig.ts';
import { signInWithPopup, GoogleAuthProvider, OAuthProvider, signOut, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail, sendEmailVerification, setPersistence, browserLocalPersistence } from "firebase/auth";
import {isMobileApp} from "../../../Utils/misc/envNameUtils.ts";
import {handleSave} from "../../../Utils/db/chatHistory/saveFullChat.ts";

export const handleGoogleSignIn = async (closeModal: any, environment: string, vscode: any, setDynamicStateObj: any, messagesSequenceRef: any, shareMessagesSequence: any, shareChatName: string, updateChatHistory: any, uuid: string | undefined) => {
    if (environment.includes("jetbrains")) {
        window.jetbrainsPostMessage(JSON.stringify({
            functionName: "signInWithGoogle",
            data: []
        }));
    } else if (environment === "vscode") {
        vscode.postMessage({ functionName: "signInWithGoogle", data: [{ _: "_" }] });
    } else if (isMobileApp(environment)) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
            functionName: "signInWithGoogle",
            data: []
        }));
    } else {
        try {
            const googleProvider = new GoogleAuthProvider();
            googleProvider.setCustomParameters({
                prompt: 'select_account'
            });
            const user = await signInWithPopup(auth, googleProvider);
            await setPersistence(auth, browserLocalPersistence);
            closeModal();
            if (uuid !== undefined) {
                messagesSequenceRef.current = shareMessagesSequence;
                await handleSave(user.user, messagesSequenceRef, updateChatHistory, setDynamicStateObj, shareChatName);
                window.location.href = '/';
            }
        } catch (error) {
            console.error("Error signing in with Google:", error);
        }
    }
};

export const handleAppleSignIn = async (closeModal: any, environment: string, setDynamicStateObj: any, messagesSequenceRef: any, shareMessagesSequence: any, shareChatName: string, updateChatHistory: any, uuid: string | undefined) => {
    if (isMobileApp(environment)) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
            functionName: "signInWithApple",
            data: []
        }));
    } else {
        try {
            const provider = new OAuthProvider('apple.com');
            const result = await signInWithPopup(auth, provider);
            await setPersistence(auth, browserLocalPersistence);
            closeModal();

            if (uuid !== undefined) {
                messagesSequenceRef.current = shareMessagesSequence;
                await handleSave(result.user, messagesSequenceRef, updateChatHistory, setDynamicStateObj, shareChatName);
                window.location.href = '/';
            }
        } catch (error) {
            console.error("Error signing in with Apple:", error);
        }
    }
};

export const handleEmailPasswordSignIn = async (e: any, isSignUp: boolean, email: string, password: string, closeModal: any, setNotification: any, environment: string, vscode: any, setUserObj: any, setDynamicStateObj: any, messagesSequenceRef: any, shareMessagesSequence: any, shareChatName: string, updateChatHistory: any, uuid: string | undefined) => {
    e.preventDefault();

    try {
        if (isSignUp) {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            setUserObj({user: null});

            const user = userCredential.user;

            await sendEmailVerification(user);
            setNotification({ message: 'A verification email has been sent. Please check your inbox and verify your email, then come back to sign in.', type: 'success' });
            await signOut(auth);
        } else {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            if (user.emailVerified) {
                closeModal();

                if (uuid !== undefined) {
                    messagesSequenceRef.current = shareMessagesSequence;
                    await handleSave(user, messagesSequenceRef, updateChatHistory, setDynamicStateObj, shareChatName);
                    window.location.href = '/';
                }

                if (environment.includes("jetbrains")) {
                    window.jetbrainsPostMessage(JSON.stringify({
                        functionName: "signInWithEmailPass",
                        data: [{email: email, password: password}]
                    }));
                } else if (environment === "vscode") {
                    vscode.postMessage({
                        functionName: "signInWithEmailPass",
                        data: [{email: email, password: password}]
                    });
                } else {
                    await setPersistence(auth, browserLocalPersistence);
                }
            } else {
                setNotification({ message: 'Please verify your email before signing in.', type: 'error' });
                await signOut(auth);
            }
        }
    } catch (error: any) {
        if (isSignUp) setNotification({ message: 'Email address already in use.', type: 'error' });
        else setNotification({ message: 'Incorrect email/password combination.', type: 'error' });
    }
};

export const handlePasswordReset = async (email: string) => {
    try {
        await sendPasswordResetEmail(auth, email);
        return true;
    } catch (error) {
        console.error("Error sending password reset email:", error);
        return false;
    }
};
